module.exports = __webpack_public_path__ + "static/media/soporteAdjuntar.4f626b26.png";